module.exports = __webpack_public_path__ + "static/media/high-tech-landscape.f0f5c7be.jpg";